import { Box, Flex, Text, Heading, Image, VStack, HStack, Icon } from '@chakra-ui/react';
import { FaArrowUp } from 'react-icons/fa';
import { FiImage } from 'react-icons/fi';
import React from 'react';
import { Listing } from "../types/types";
import InstagramStoryOverlay from './InstagramStoryOverlay';

interface StoryContentProps {
  name: string;
  listings: Listing[] | null;
}

function StoryContent({ name, listings }: StoryContentProps) {
  return (
    <Box 
      position="relative" 
      h="100%" 
      w="100%" 
      bg="black" 
      pb="100px"
      color="white"
      px={4}
      pt={0}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      _before={{
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage:
          listings && listings[0] && listings[0].listing_images[0]
            ? `url(${listings[0].listing_images[0].image})`
            : 'none',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right',
        opacity: 0.2,
        zIndex: 0,
      }}
    >
      <Flex align="center" gap={3} mb={10} pt={0} ml={-24}>
        <Box fontSize="xl" transform="rotate(-45deg)">
          <FaArrowUp />
        </Box>
        <Text fontSize="md" fontWeight="light" mt={6} ml={-2}>
          CHECK THE LINK IN THE BIO
        </Text>
      </Flex>

      <Text fontSize="md" mb={3} fontWeight="medium" letterSpacing="wide">
        ANNOUNCING
      </Text>
      <Heading fontSize="4xl" mb={10} fontWeight="bold" textAlign="center" alignItems="center">
        {name}
      </Heading>

      <VStack spacing={8} align="stretch" w="full">
        {listings &&
          listings.slice(0, 4).map((listing, i) => (
            <HStack key={listing.id} spacing={6}>
              {listing.listing_images?.[0]?.image ? (
                <Image
                  src={listing.listing_images[0].image}
                  alt={listing.listing_images[0].alt_text || 'Listing image'}
                  boxSize="60px"
                  borderRadius="16px"
                  objectFit="cover"
                  bg="black"
                />
              ) : (
                <Box
                  boxSize="60px"
                  borderRadius="16px"
                  bg="gray.100"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon as={FiImage} boxSize={8} color="gray.400" />
                </Box>
              )}
              <Text fontSize="md" fontWeight="medium" flex="1">
                {listing.title}
              </Text>
            </HStack>
          ))}
      </VStack>
    </Box>
  );
}

interface InstagramStoryFallbackProps {
  profileUrl: string;
  username: string;
  timestamp: string;
  listings: Listing[];
}

export default function InstagramStoryFallback({ profileUrl, username, timestamp, listings }: InstagramStoryFallbackProps) {

  return (
    <div>
      <StoryContent name={username} listings={listings} />

      <InstagramStoryOverlay
        profileUrl={profileUrl}
        username={username}
        timestamp={timestamp}
        isFallback={true}      
      />
    </div>
  );
}
